import { createContext, useContext } from 'react';
import memoize from 'react-utils/memoize';
import devLogger from 'react-utils/devLogger';

export const defaultDropdownContext = {
  shouldLogModalWarning: false,
};

export const DropdownContext = createContext(defaultDropdownContext);

const { Provider } = DropdownContext;

export { Provider as DropdownContextProvider };

let hasReportedDropdown = false;
export const createPlacementWarning = memoize((componentName) => () => {
  if (hasReportedDropdown) return;
  if ((window as any).newrelic) {
    (window as any).newrelic.addPageAction(`componentInDropdown`, {
      componentName,
    });
  }
  if (process.env.NODE_ENV !== 'production') {
    devLogger.warn({
      message: `A \`${componentName}\` was rendered within a \`UIDropdown\`. Please refactor.`,
      url: 'https://github.com/HubSpotEngineering/UIComponents/issues/8857',
      key: `${componentName}-in-dropdown`,
    });
  }
});

export const DropdownContextComponent = ({
  componentName,
}: {
  componentName: string;
}) => {
  const { shouldLogModalWarning } = useContext(DropdownContext);
  const memoizedCreatePlacementWarning = createPlacementWarning(componentName);

  if (shouldLogModalWarning) {
    memoizedCreatePlacementWarning();
  }
  return null;
};

// For testing only
export const resetDropdownReporter = () => {
  hasReportedDropdown = false;
};
